import type { CSSProperties, ReactNode } from "react";
import "./index.css";
import { clsx } from "clsx";
import { cloneWithClassName } from "../../utils";
import { CopyIconButton } from "../CopyButton";
import { Skeleton } from "../Skeleton";
import { Text } from "../Text";
import type { ILabelValueProps } from "./types";

const renderContent = (
  content: ReactNode,
  className: string,
  style?: CSSProperties,
) => {
  return (
    cloneWithClassName(content, className, style) || (
      <Text size="lg" as="div" style={style} className={className}>
        {content}
      </Text>
    )
  );
};

export const LabelValue = ({
  label,
  value,
  direction = "row",
  labelWidth,
  canCopy = false,
  copyText,
  loading,
  className,
  onRenderValue,
  gap,
  fullWidth,
}: ILabelValueProps) => {
  const rootClass = clsx(
    "label-value",
    `label-value--${direction}`,
    gap && `label-value--gap-${gap}`,
    fullWidth && `label-value--fullWidth`,
    className,
  );
  const copyContent: string = copyText || `${value}`;

  return (
    <div className={rootClass}>
      {renderContent(label, "label-value__label", {
        minWidth: labelWidth,
        maxWidth: labelWidth,
      })}
      <div className="label-value__value-wrapper">
        {loading ? (
          <Skeleton width="12.5rem" height="1.5rem" />
        ) : onRenderValue ? (
          onRenderValue()
        ) : (
          <>
            {renderContent(value, "label-value__value")}
            {canCopy && (
              <div className="label-value__copyIcon">
                <CopyIconButton
                  size="xs"
                  variant="soft"
                  color="neutral"
                  copyContent={copyContent}
                  className="label-value__copyIcon-button"
                />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};
